import React from "react";
import { Link } from "react-router-dom";

// font-bold. font-semibold font-medium, font-normal

/* 30px */
export const HeadingFive = ({ className, children, color, title }) => {
  return (
    <h5 title={title} className={`text-3xl ${color} ${className}`}>
      {children}
    </h5>
  );
};

/* 48px */
export const HeadingTwo = ({ className, children, color, padding, title }) => {
  return (
    <h2 title={title} className={`text-5xl ${color} ${padding} ${className}`}>
      {children}
    </h2>
  );
};
/* 20px */
export const HeadingSix = ({ className, children, color, padding, title }) => {
  return (
    <h6 title={title} className={`text-xl ${color} ${padding} ${className}`}>
      {children}
    </h6>
  );
};

/* 18px */
export const Paragraph1 = ({ className, children, color, padding, title }) => {
  return (
    <p title={title} className={`text-lg ${color} ${padding} ${className}`}>
      {children}
    </p>
  );
};

/* 16px */
export const Paragraph2 = ({ className, children, color, padding, title }) => {
  return (
    <p title={title} className={`text-base ${color} ${padding} ${className}`}>
      {children}
    </p>
  );
};

/* 14px */
export const Paragraph3 = ({ className, children, color, padding, title }) => {
  return (
    <p title={title} className={`text-sm ${color} ${padding} ${className}`}>
      {children}
    </p>
  );
};
/* 36px */
export const HeadingThree = ({
  className,
  children,
  color,
  padding,
  title,
  margin,
}) => {
  return (
    <h3
      title={title}
      className={`text-4xl ${color} ${margin} ${padding} ${className}`}
    >
      {children}
    </h3>
  );
};

/* 30px */
export const HeadingFour = ({
  className,
  children,
  color,
  padding,
  title,
  margin,
}) => {
  return (
    <h4
      title={title}
      className={`text-3xl ${color} ${margin} ${padding} ${className}`}
    >
      {children}
    </h4>
  );
};

export const LabelText = ({ id, label, required, className }) => {
  if (!label) return null;
  return (
    <label
      className={`block tracking-wide mb-1 text-gray-500 text-sm font-bold ml-1  ${
        required ? "required" : ""
      } ${className}`}
      htmlFor={id}
    >
      {label}
    </label>
  );
};

//rarely user

export const BiggestSizeFont = ({
  className,
  children,
  color,
  padding,
  title,
}) => {
  return (
    <h1 title={title} className={`text-7xl ${color} ${padding} ${className}`}>
      {children}
    </h1>
  );
};

/* 60px */
export const HeadingOne = ({
  className,
  children,
  color,
  padding,
  title,
  margin,
}) => {
  return (
    <h1
      title={title}
      className={`text-6xl  ${color} ${margin} ${padding} ${className}`}
    >
      {children}
    </h1>
  );
};

export const ErrorText = ({ errorStr, className }) => {
  let color = "text-red-500";
  return (
    <Paragraph3 color={color} className={`${className}`} padding="pb-1">
      {errorStr}
    </Paragraph3>
  );
};

export const FooterLink = ({ className, link, padding, title, margin }) => {
  return (
    <Link to={`${link}`} className={`${className} ${margin} ${padding}`}>
      {title}
    </Link>
  );
};
